module.exports = __webpack_public_path__ + "img/0913_1.e6c9cd8c.jpg";